import aiTools from '@motionelements/core/src/store/modules/ai-tools.js';

export default {
  namespaced: true,
  state: aiTools.state,
  getters: aiTools.getters,
  actions: aiTools.actions,
  mutations: aiTools.mutations,
};
